exports.connect = {
	url: "https://api.loscolo.camp/"
}
